import { useTranslation } from 'react-i18next';

export function FocusBanner({
  rowId,
  onShowAll,
}: {
  rowId: number;
  onShowAll: () => void;
}) {
  const { t } = useTranslation('inventory-import');
  return (
    <div className="flex items-center justify-between rounded-md bg-prim-50 px-3 py-2 text-xs text-neut-prim">
      <span>{t('review.showing_only_row', { id: rowId })}</span>
      <button
        type="button"
        onClick={onShowAll}
        className="font-medium text-prim underline hover:opacity-80"
      >
        {t('review.show_all_rows')}
      </button>
    </div>
  );
}
